export const LEGACY_AUDIO_MESSAGE_RECORD_MODAL_NAME = 'legacyAudioMessageRecord';

export const AUDIO_EXAMPLE_SRC = 'https://dev.youhelp.ru/assets/4d3d9c5c.mp3';
